"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localisedStrings = void 0;
exports.localisedStrings = {
    en: {
        back: 'Back',
        login: 'Login',
        noInternetAccess: 'No internet connection',
        toLogin: 'to login?',
        use: 'Use',
        biometricPageDescriptionSegmentPrefix: 'You can use',
        receivePushNotifications: 'Receive Notifications for New Reports?',
        pushNotificationsDescription: 'Stay on top of your portfolio and get notifications when new reports are available to download',
        enablePushNotifications: 'Enable Push Notifications',
        maybeLater: 'Maybe later',
        usePassword: 'No, use password each time',
        biometricPageDescriptionSegmentSuffix: "to access your account, so you won't need to type your password each time.",
        portfolio: 'Portfolio',
        next: 'Next',
        chooseBio: 'Would you like to use Face ID or Touch ID for quicker login next time?',
        useFaceId: 'Use Face ID',
        useTouchId: 'Use Touch ID',
        logout: 'Log Out',
        email: 'Email',
        call: 'Call',
        scheduleAppointment: 'Schedule Appointment',
        totalReturnInception: 'Total Return Since Inception',
        totalReturnDate: 'Total Return Since',
        totalReturn: 'Total Return',
        yourNetWorth: 'Your Net worth',
        hi: 'Hi',
        settings: 'Settings',
        poweredBy: 'Powered By',
        lastSync: 'Last Sync',
        version: 'Version',
        adviser: 'Adviser',
        TouchID: 'Touch ID',
        FaceID: 'Face ID',
        Biometrics: 'Biometrics',
        holdings: 'Holdings',
        portfolioPercent: 'Portfolio %',
        value: 'Value',
        units: 'Units',
        lastPrice: 'Last Price',
        marketValue: 'Market Value',
        viewAllHoldings: 'View All Holdings',
        hundredPercent: '100%',
        weight: 'Weight',
        cost: 'Cost',
        estLossGain: 'Est. Gain/Loss',
        allAssetClasses: 'All Asset Classes',
        assetClasses: 'Asset Class',
        viewAllTransactions: 'View All Transactions',
        buy: 'Buy',
        inFees: 'in fees',
        appUpdateAlertTitle: 'Update Required',
        appUpdateButtonTextAndroid: 'Open Play Store',
        appUpdateButtonTextIos: 'Open App Store',
        appUpdateAlertMessage: "A new version of this app is available. You'll need to download the update from your app store to continue using the app.",
        errorBoundaryText: 'Something went wrong.',
        transactionsHeading: 'Transactions',
        allTransactions: ' All Transactions',
        recentTransactions: 'Your most recent transactions.',
        holdingsAsOf: 'Holdings As Of',
        reportsHeading: 'Reports',
        viewAllReports: 'View All Reports',
        added: 'Added',
        unableToLoadDataForGraph: 'Unable to load data for graph',
        unableToLoadData: 'Unable to load data',
        retry: 'Retry',
        couldNotLoadData: 'We couldn’t load your data at this time.',
        performance: 'Performance',
        assetAllocation: 'Asset Allocation',
        allocationsAsOf: 'Allocation As Of',
        recentReportHoldings: 'Recent reports related to your holdings.',
        currentValue: 'Current Value',
        capitalReturn: 'Capital Return',
        incomeReturn: 'Income Return',
        includeCashTransactions: 'Include Cash Transactions',
        noTransactionDataWithFilters: 'No data found with the selected Filters.',
        searchTransactions: 'Search transactions',
        noReports: 'There are no reports available at this time.',
        noTransactions: 'There are no transactions available at this time.',
        noAssetAllocations: 'There is no asset allocation data available at this time.',
        noPerformance: 'There is no performance data available at this time.',
        nA: 'N/A',
        chooseBenchmark: 'Choose Benchmark',
        chooseBenchmarkDescription: 'Choose a benchmark to compare your portfolio performance against.',
        compareAgainstBenchmark: 'Compare Against Benchmark',
        changePassword: 'Change Password',
        pushNotifications: 'Push Notifications',
        termsAndConditions: 'Terms and Conditions',
        devEnvironment: 'Dev',
        stagingEnvironment: 'Staging',
        productionEnvironment: 'Production',
        changeEnvironment: 'Change Environment',
        errorMessage: 'Unable to retrieve data from the server. Please try again.',
        changeEnvironmentModalMessage: "Changing environments will log you out of your current session and change environments. You'll need to login again with a valid account for that new environment. Are you sure you want to logout and change environments?",
        cancel: 'Cancel',
        ok: 'Ok',
        changePasswordModalTitle: 'Change Password Link Sent',
        changePasswordModalMessage: "We've sent you an email with a link you can use to change your password. If you don't see it in your inbox in a couple of minutes, please check your junk email folder.",
        bundleId: 'BundleID',
        slot: 'Slot',
        total: 'total',
        fileDownloadedSuccessfully: 'File downloaded successfully',
        unableToDownloadFile: 'Unable to download file. Please try again',
        permissionToDownloadFile: 'Client Portal needs permission to download the file',
        permissionDeniedToDownloadFile: 'Permission denied, unable to download file',
        unableToObtainPermissionToDownloadFile: 'Unable to obtain permission to download file',
        selectContact: 'Select Contact',
        searchContact: 'Search Contact',
        noContactsAvailable: 'No contacts available',
        adviserMode: 'Adviser Mode',
        unableToLogin: 'Unable to Login',
        clockOutOfSyncErrorModalMessage: 'Please ensure the date and time of your device is set correctly, or that your device is set to "automatic" mode and try again.',
        sessionExpiredTitle: 'Session Expired',
        sessionExpiredBody: 'Your session has expired. Please login again to continue.',
        currentServerEnvironmentAlreadyDev: 'You are already in the dev environment',
        currentServerEnvironmentAlreadyStaging: 'You are already in the staging environment',
        currentServerEnvironmentAlreadyProduction: 'You are already in the production environment',
        devTools: 'Dev Tools',
        expireAccessToken: 'Expire Access Token',
        tokenExpirationTitle: 'Token has expired',
        tokenExpirationDescription: 'If you want to test the app behavior on token expiration (prompt biometric auth), please restart the app.',
        logoutMessage: 'Are you sure you want to logout?',
        whatsNew: `What's New`,
        continue: 'Continue',
    },
};
